import axios from 'axios';
import { auth } from '../../../services';
import { ROOT_API_URL } from '../../../api-config';
import { push } from 'react-router-redux';

export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_CONFIRMED = 'CHANGE_PASSWORD_CONFIRMED';
export const CHANGE_PASSWORD_CANCELED = 'CHANGE_PASSWORD_CANCELED';
export const RESET_CHANGE_PASSWORD = 'RESET_CHANGE_PASSWORD';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const GET_AUTHENTICATED_USER_SUCCESS = 'GET_AUTHENTICATED_USER_SUCCESS';
export const GET_AUTHENTICATED_USER_REQUEST = 'GET_AUTHENTICATED_USER_REQUEST';
export const SET_USER_ID = 'SET_USER_ID';

export const getLoggedinUser = () => {
    return (dispatch) => {
        var email = auth.getAuthUserEmail();
        dispatch({
            type: GET_AUTHENTICATED_USER_REQUEST,
            payload: email
        });
        var url = `${ROOT_API_URL}/users/profile`;
        const options = {
            method: 'POST',
            headers: auth.authHeader()
        };
        axios.post(url, {
            email: email
        }, options)
            .then((res) => {
                if (res && res.data && res.data.userName) {
                    dispatch({
                        type: GET_AUTHENTICATED_USER_SUCCESS,
                        payload: res.data
                    });
                } else {
                }
            })
            .catch((res) => {
                localStorage.setItem('authUser', null);
                window.location.href = "/login";
            });
    };
};

export const login = (email, password) => {
    return (dispatch) => {
        dispatch(request({ email }));



        auth.login(email, password).then(
            (res) => {
                //console.log(res.data);
                console.log(res.data);
                console.log(res.data.permissions);
                var route = '/admin/users';


                if (res && res.data && res.data.success) {
                    var user = {
                        token: res.data.token,
                        email: res.data.userName,
                        roles: res.data.roles,
                        permissions: res.data.permissions,
                        userId: res.data.userId
                    };

                    if (res.data.permissions.filter(e => e.value === 'Accounting').length > 0) {
                        route = '/admin/purchaseandrenewals';
                    }

                    if (res.data.permissions.filter(e => e.value === 'Membership').length > 0) {
                        route = '/admin/membership';
                    }

                    auth.setToken(user);
                    dispatch(success(email));
                    if (auth.isInRole('INTERNAL')) {
                        dispatch(push(route))
                    } else if (auth.isInRole('RANGER')) {
                        dispatch(push('/admin/rangers'));
                    } else if (!res.data.isSignedup) {

                        var showDashboard = false;
                        var loginData = res.data;

                        if (!user.userId) {
                            throw new Error('Unable to get the User ID');
                        }

                        const options = {
                            method: 'GET',
                            headers: auth.authHeader()
                        };

                        axios.get(
                            `${ROOT_API_URL}/Users/GetMemberships?userId=${user.userId}`,
                            options
                        ).then((memberships) => {

                            dispatch({
                                type: SET_USER_ID,
                                payload: loginData.userId
                            })

                            if (memberships && memberships.data && memberships.data.length) {
                                showDashboard = true;
                                dispatch(push('/dashboard'));
                                return;
                            } else {
                                axios.get(
                                    `${ROOT_API_URL}/Users/GetInvitations?userId=${user.userId}`,
                                    options
                                ).then((invitations) => {

                                    if (invitations && invitations.data && invitations.data.length) {
                                        dispatch(push('/dashboard'));
                                    } else {

                                        dispatch(push('/membership'));

                                    }

                                }).catch((res) => {
                                    throw new Error('Unable to get Invitations');
                                });
                            }

                        }).catch((res) => {
                            throw new Error('Unable to get Memberships');
                        });

                    } else {
                        dispatch({
                            type: SET_USER_ID,
                            payload: res.data.userId
                        })
                        dispatch(push('/dashboard'))
                    }
                }
                else {
                    var err = res && res.data ? res.data.message : 'Error Occured';
                    dispatch(failure(err));
                    dispatch({
                        type: SET_USER_ID,
                        payload: res.data.userId
                    })
                    if (!res.data.isSignedup && res.data.Success) {
                        dispatch(push('/membership'))

                    }
                    // dispatch(alertActions.error(err));
                }
            },
            (error) => {
                dispatch(failure(error.toString()));
                // dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request(email) {
        return { type: LOGIN_REQUEST, payload: email };
    }
    function failure(error) {
        return { type: LOGIN_ERROR, payload: error };
    }
    function success(email) {
        return { type: LOGIN_SUCCESS, payload: email };
    }
};

export const logout = () => {
    auth.removeToken();
    window.location = '/';
    return { type: LOGOUT };
};

export const changePasswordSuccess = (payload) => ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload
});

export const changePasswordError = (payload) => ({
    type: CHANGE_PASSWORD_ERROR,
    payload
});

export const changePasswordRequest = (payload) => ({
    type: CHANGE_PASSWORD_REQUEST,
    payload
});

export const resetChangePassword = (payload) => ({
    type: RESET_CHANGE_PASSWORD,
    payload
});

export const changePassword = (email, currentPassword, newPassword) => {
    return (dispatch) => {
        dispatch({
            type: CHANGE_PASSWORD_REQUEST,
            payload: email
        });
        var model = {
            email: email,
            currentPassword: currentPassword,
            newPassword: newPassword
        };
        const options = {
            method: 'POST',
            headers: auth.authHeader()
        };
        var error = 'Error Occured. Please try again or contact administrator';
        axios
            .post(`${ROOT_API_URL}/account/changepassword`, model, options)
            .then((response) => {
                if (response && response.data && response.data.issuccess) {
                    dispatch({
                        type: CHANGE_PASSWORD_SUCCESS,
                        payload: email
                    });
                } else {
                    dispatch({
                        type: CHANGE_PASSWORD_ERROR,
                        payload: response && response.data ? response.data.message || error : error
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                dispatch({
                    type: CHANGE_PASSWORD_ERROR,
                    payload: error
                });
            });
    };
};
